// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../layout-and-structure/Stack.res.js";
import * as Button from "../actions/Button.res.js";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as DayPickerRange from "./DayPickerRange.res.js";
import * as Stdlib_Nullable from "@rescript/runtime/lib/es6/Stdlib_Nullable.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
import * as InputRadioGroupField from "./InputRadioGroupField.res.js";
function getMaxDate() {
  return DateHelpers.endOfDay(new Date());
}
function isOutsideRange(date) {
  return date.getTime() > DateHelpers.endOfDay(new Date()).getTime();
}
function DateRangePicker(props) {
  let onNextMonthClick = props.onNextMonthClick;
  let onPrevMonthClick = props.onPrevMonthClick;
  let onRequestReset = props.onRequestReset;
  let __hidePresets = props.hidePresets;
  let __hideResetButton = props.hideResetButton;
  let range = props.range;
  let visibleMonth = props.visibleMonth;
  let __focusedInput = props.focusedInput;
  let focusedInput = __focusedInput !== undefined ? __focusedInput : DayPickerRange.defaultFocusedInput;
  let hideResetButton = __hideResetButton !== undefined ? __hideResetButton : false;
  let hidePresets = __hidePresets !== undefined ? __hidePresets : false;
  let onPrevMonthClick$1 = date => onPrevMonthClick(date);
  let onNextMonthClick$1 = date => onNextMonthClick(date);
  let initialVisibleMonth = () => visibleMonth;
  let tmp;
  if (hidePresets) {
    tmp = null;
  } else {
    let newrecord = {
      ...{
        className: "borderRightColor-x1eoc22 borderRightStyle-x32b0ac borderRightWidth-xs1s249 minHeight-x1lhurn5 padding-x1qhigcl",
        "data-style-src": "wino-gc:src/resources/selection-and-input/DateRangePicker.res.js:25"
      }
    };
    tmp = JsxRuntime.jsxs("div", (newrecord.children = [JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Period"),
        variation: "normal",
        weight: "semibold",
        size: "xxsmall"
      }),
      spaceBottom: "small"
    }), JsxRuntime.jsx(InputRadioGroupField.make, {
      value: props.activePreset,
      required: false,
      onChange: props.onChangePreset,
      isEqualValue: props.isEqualPreset,
      options: props.presets,
      optionToText: props.formatPreset
    }), hideResetButton ? null : JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Reset period"),
        variant: "subtle",
        size: "small",
        disabled: Stdlib_Nullable.fromOption(range[1]) == null,
        icon: "delete",
        onPress: onRequestReset
      }),
      spaceTop: "medium"
    })], newrecord));
  }
  return JsxRuntime.jsxs(Inline.make, {
    children: [tmp, JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(DayPickerRange.make, {
        startDate: range[0],
        endDate: range[1],
        maxDate: DateHelpers.endOfDay(new Date()),
        initialVisibleMonth: initialVisibleMonth,
        isOutsideRange: isOutsideRange,
        focusedInput: focusedInput,
        onChange: props.onDatesChange,
        onFocusChange: props.onFocusChange,
        onPrevMonthClick: onPrevMonthClick$1,
        onNextMonthClick: onNextMonthClick$1
      }, visibleMonth.toDateString()), !hideResetButton && hidePresets ? JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Inline.make, {
          children: JsxRuntime.jsx(Button.make, {
            label: I18n.t("Reset period"),
            variant: "subtle",
            size: "small",
            disabled: Stdlib_Nullable.fromOption(range[1]) == null,
            icon: "delete",
            onPress: onRequestReset
          }),
          align: "end"
        }),
        spaceX: "large",
        spaceBottom: "medium"
      }) : null]
    })]
  });
}
let make = DateRangePicker;
export { getMaxDate, isOutsideRange, make };
/* styles Not a pure module */